import { t } from './index.js'

/** 解析搜索项 label（支持 labelKey） */
export function resolveSearchLabel(item) {
  if (item.labelKey) return t(item.labelKey)
  return item.label || ''
}

/** 解析搜索项 placeholder */
export function resolveSearchPlaceholder(item) {
  if (item.placeholderKey) return t(item.placeholderKey)
  if (item.placeholder) return item.placeholder
  return t('pleaseInput')
}

/** 解析表格列 label（支持 labelKey） */
export function localizeColumns(columns) {
  return columns.map((col) => ({
    ...col,
    label: col.labelKey ? t(col.labelKey) : col.label,
  }))
}

/** 状态选项（启用/停用） */
export function statusOptionsI18n() {
  return [
    { label: t('all'), value: 0 },
    { label: t('field.roleMachinist'), value: 1 },
    { label: t('field.roleCaptain'), value: 2 },
    { label: t('field.roleAdmin'), value: 99 },
  ]
}

/** 设备状态 */
export function deviceStatusOptionsI18n(includeAll = false) {
  const opts = [
    { label: t('status.available'), value: 1 },
    { label: t('status.warehouse'), value: 0 },
  ]
  if (includeAll) return [{ label: t('all'), value: 99 }, ...opts]
  return opts
}

/** 用户状态 */
export function userStatusOptionsI18n() {
  return [
    { label: t('status.enabled'), value: 1 },
    { label: t('status.disabled'), value: 0 },
  ]
}

/** 在职状态 */
export function employmentOptionsI18n(includeAll = false) {
  const opts = [
    { label: t('status.onJob'), value: 1 },
    { label: t('status.offJob'), value: 0 },
  ]
  if (includeAll) return [{ label: t('all'), value: 99 }, ...opts]
  return opts
}
